'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationConstants = require('../../validationConstants');

var URL_ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.url,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    debounced: true,
    message: 'Not a valid url'
};

exports.default = function (fieldValue, validationConfig) {
    if (!fieldValue) return null;

    if (fieldValue.match(_validationConstants.URL_REGEX)) return null;
    if (validationConfig.allowIPAddress && fieldValue.match(_validationConstants.IP_ADDRESS_REGEX)) return null;
    if (process.env.NODE_ENV === 'development' && fieldValue.match(_validationConstants.LOCALHOST_REGEX)) return null;

    return URL_ERROR_OBJECT;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/urlValidator.js
// module id = 2310
// module chunks = 0